import React from "react";

export const genderList = [
  {
    text: "男",
    Info: 1,
  },
  {
    text: "女",
    Info: 0,
  },
];

export const typeList = [
  {
    text: "学生",
    Info: 1,
  },
  {
    text: "家长",
    Info: 2,
  },
];

export const OptionFunContext = React.createContext({
  checkPlan: (item) => {},
  enroll: (item: any, type?: string) => {},
});
